import React , {Component} from 'react';
import {
    Page ,  Link
} from 'framework7-react';
import NumberFormat from 'react-number-format';


import { connect } from "react-redux";
import {addToUserCart , removeFromUserCart , addToCart , removeFromCart , toolbar ,
    removeProductFromCart ,
    removeProductFromUserCart } from "../actions";
import Food2Card from "../Cards/Food2Card";

class Cart extends Component{

    onPageBeforeIn(){
        this.props.toolbar(false)
    }

    componentDidMount(){
        if (this.props.branch.length === 0)
        {
            this.$f7router.navigate('/')
            return false
        }
    }

    render() {
        const {addToCart, removeFromCart, products, addToUserCart, removeFromUserCart, cart, branch  , removeProductFromCart , removeProductFromUserCart } = this.props


       /* if (branch.length === 0)
        {
            this.$f7router.navigate('/')
            return false
        }*/


        let cartCount = 0
        cart.forEach(function ( item ) {
            cartCount += item
        })

        let maxBranchDiscount = 0
        if (branch.length !== 0)
        {
            branch.discounts.map((item , index)=> {
                if (parseInt(item.percent_branchs) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_branchs)
                }
                if (parseInt(item.percent_app) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_app)
                }
            })
        }

        let totalPrice = 0
        let totalDiscount = 0
        cart.forEach( function(count , id){
                totalPrice += products[id]["price"] * count
                totalDiscount += products[id]["price"] * count * products[id]["food_discount"] / 100
            }
        )

        totalDiscount =  Math.round(totalDiscount + ( (totalPrice - totalDiscount)  * maxBranchDiscount / 100))


        let taxPrice =  Math.round(totalPrice * branch.tax / 100)
        let payablePrice = totalPrice - totalDiscount + taxPrice

        return(
            <Page name="Cart" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>
                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        سبد خرید
                        (
                        {branch.title_fa}
                        )
                    </div>
                </div>
                <div id="inner-header-separator" />
                <div id="cart-foods-container">

                    {
                        cart.map((count , id)=>
                            <Food2Card key={id} count={count} object={products[id]} onRemoveProductFromCartClicked={()=>[removeProductFromCart(id) , removeProductFromUserCart(id) ]} onRemoveFromCartClicked={() => [removeFromCart(id) , removeFromUserCart(id)]} onAddToCartClicked={() => [addToCart(id) ,addToUserCart(id)]} />
                        )
                    }
                </div>


                {
                    cartCount > 0 ? (

                            <div id="cart-footer">
                                <div className="content">

                                    <div className="b-container b-0 ">

                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="total">
                                                    جمع کل و مالیات
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="total">
                                                    {<NumberFormat value={totalPrice} displayType={'text'} thousandSeparator={true}  />} تومان


                                                </div>
                                            </div>
                                        </div>


                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="discount">
                                                    تخفیف ویژه
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="discount">
                                                    {<NumberFormat value={totalDiscount} displayType={'text'} thousandSeparator={true}  />} تومان

                                                </div>
                                            </div>
                                        </div>


                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="payable">
                                                    مبلغ کل
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="payable">
                                                    {<NumberFormat value={payablePrice} displayType={'text'} thousandSeparator={true}  />} تومان

                                                </div>
                                            </div>
                                        </div>



                                    </div>



                                </div>

                                <Link href={localStorage.getItem('logged') !== undefined && localStorage.getItem('logged') !== null ? `/address/` : `/login-singup/`} className="btn btn-block " id="go-to-address-select">
                                    ادامه ( انتخاب آدرس)
                                </Link>
                            </div>
                        ) :
                        ( `` )
                }
            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    addToCart : productId => dispatch(addToCart(productId)) ,
    removeFromCart : productId => dispatch(removeFromCart(productId)) ,
    removeProductFromCart : productId => dispatch(removeProductFromCart(productId)) ,


    addToUserCart : productId => dispatch(addToUserCart(productId)) ,
    removeFromUserCart : productId => dispatch(removeFromUserCart(productId)) ,
    removeProductFromUserCart : productId => dispatch(removeProductFromUserCart(productId)) ,

    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch ,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(Cart);